import { incomingCalls } from './api.ts';

/**
 * "Riporta alla console quando squilla."
 *
 * Il riquadro della chiamata, il suono, l'annuncio `assertive` e la
 * scorciatoia per rispondere vivono nella console. Ma la console stessa
 * manda altrove — "vai alle notifiche", "i miei turni" — e la prova di
 * notifica si fa proprio al primo turno: chi la sta facendo si trovava in una
 * schermata muta, e una chiamata poteva passare al volontario successivo senza
 * che lui sapesse niente.
 *
 * Questa non è una seconda macchina a stati: non tiene niente, non decide
 * niente, e non sa cosa fare di una chiamata. Chiede solo "c'è qualcuno che
 * aspetta?" mentre si è **fuori** dalla console, e in quel caso ci riporta. Da
 * lì in poi decide la console, che è l'unica a saperlo fare.
 */

/** Lo stesso ritmo della console: chi aspetta non deve stare più del dovuto. */
const WATCH_MS = 3000;

export function watchIncoming(onIncoming: () => void): () => void {
  let stopped = false;

  const look = async (): Promise<void> => {
    try {
      const result = await incomingCalls();
      if (!stopped && result.incoming) onIncoming();
    } catch {
      // Una lettura persa non cambia niente: al giro dopo ci riprova, e la
      // console resta comunque raggiungibile a mano.
    }
  };

  void look();
  const handle = setInterval(() => void look(), WATCH_MS);

  return () => {
    stopped = true;
    clearInterval(handle);
  };
}
